import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InvalidPhotoUiCode } from '@shared/types/instant-checkup.types';

@Component({
  selector: 'app-invalid-photo-error-card',
  templateUrl: './invalid-photo-error-card.component.html',
  standalone: true,
  imports: [CommonModule],
})
export class InvalidPhotoErrorCardComponent {
  @Input() uiCode: InvalidPhotoUiCode = InvalidPhotoUiCode.FALLBACK;

  InvalidPhotoUiCode = InvalidPhotoUiCode;

  get isMultiMessage(): boolean {
    return this.uiCode !== InvalidPhotoUiCode.FACE_NOT_FOUND;
  }
}
